import { render } from "./Part.vue?vue&type=template&id=65dbb12b&scoped=true&bindings={}"
import script from "./Part.vue?vue&type=script&lang=ts"
export * from "./Part.vue?vue&type=script&lang=ts"

import "./Part.vue?vue&type=style&index=0&id=65dbb12b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-65dbb12b"

export default script